uniform vec3 uColor;
uniform float uGridSize;

varying vec2 vUv;
varying float vMouseEffect;

void main() {
    // Base color (white)
    vec3 baseColor = uColor;
    
    // Glow color (blue)
    vec3 glowColor = vec3(0.0, 0.7, 1.0);
    
    // Create a grid pattern
    vec2 gridFract = fract(vUv * uGridSize);
    float gridLine = step(0.9, max(gridFract.x, gridFract.y));
    
    // Mix base color with glow color based on mouse effect
    vec3 finalColor = mix(baseColor, glowColor, vMouseEffect);
    
    // Add grid lines when mouse is near
    if (vMouseEffect > 0.05) {
        finalColor = mix(finalColor, vec3(0.3, 0.8, 1.0), gridLine * 0.5 * vMouseEffect);
    }
    
    // Output final color
    gl_FragColor = vec4(finalColor, 1.0);
}